__turbopack_context__.v({
  "achieveRow": "Achievements-module-scss-module__jlc_ya__achieveRow",
  "card": "Achievements-module-scss-module__jlc_ya__card",
  "col": "Achievements-module-scss-module__jlc_ya__col",
  "heading": "Achievements-module-scss-module__jlc_ya__heading",
  "imgBox": "Achievements-module-scss-module__jlc_ya__imgBox",
  "label": "Achievements-module-scss-module__jlc_ya__label",
  "main": "Achievements-module-scss-module__jlc_ya__main",
  "textBox": "Achievements-module-scss-module__jlc_ya__textBox",
  "value": "Achievements-module-scss-module__jlc_ya__value",
});
